import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRouter from './App';

// Check for admin BEFORE React renders anything
const isAdmin = window.location.hash === "#admin" || 
                window.location.hash.startsWith("#admin") ||
                window.location.search === "?admin" ||
                window.location.search.startsWith("?admin");

if (isAdmin) {
  document.title = "Vaultr Admin";
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);
